import { render, staticRenderFns } from "./bannerMessage.vue?vue&type=template&id=28eccccd&"
import script from "./bannerMessage.vue?vue&type=script&lang=js&"
export * from "./bannerMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports